/**
 * TODO: deprecate this file and use the new useApplicationNotifications hook
 */
import React, { Component, createRef } from 'react'
import { render } from 'react-dom'
import PropTypes from 'prop-types'
import { FixedMessage, Text } from '@adc/ui-core'

/**
 * TODO: Need to support roles based on notifier interface
 */
class FixedMessageNotification extends Component {
  constructor() {
    super()

    this.state = { isVisible: false }

    // TODO: Clean me up when I unmount Connor. Don't leave me hanging here you British oaf
    this.cleanupTimeout = null
  }

  componentWillUnmount() {
    window.clearTimeout(this.cleanupTimeout)
  }

  notify(notification) {
    this.setState({
      isVisible: true,
      ...notification,
    })

    // TODO: I need to invetsigate differnt patterns here. We need to consider what happens when multiple updates come
    // at the same time. Perhaps we destroy the existing timeout and start agin no matter and that's just fine.
    //
    // NOTE: This seems odd, but it's exactly what apps do right now, just abstracted away in async actions.
    this.cleanupTimeout && window.clearTimeout(this.cleanupTimeout)
    this.cleanupTimeout = window.setTimeout(() => this.resetState(), 5000)
  }

  resetState() {
    this.setState({
      isVisible: false,
      message: null,
      title: null,
    })
  }

  render() {
    const { isVisible, message, title, role } = this.state

    // NOTE: This has a `transition` in some apps. I removed that here because if we remove the message and title, but
    // transition the containing element, there exists a janky empty box transitioning for half a second. We could solve
    // that with 2 timeouts, one for the `isVisible` to transition out, and then a second to reset the full state to
    // empty out the text and message.
    return (
      <div data-elm-id='Message_Notification auctionapp_notifier_fixed'>
        <FixedMessage
          centered
          role={role}
          isCloseable={false}
          style={{
            position: 'fixed',
            right: '20%',
            left: '20%',
            width: 'auto',
            zIndex: 80,
            top: isVisible ? '70px' : '-100%',
            opacity: isVisible ? 1 : 0,
            textAlign: 'center',
          }}
        >
          <div data-elm-id='Message'>
            {title && (
              <Text.Header
                data-elm-id='Message-title auctionapp_notifier_fixed_title'
                level='3'
                className='u-mb-1'
              >
                {title}
              </Text.Header>
            )}
            {message && (
              <Text
                data-elm-id='Message-message auctionapp_notifier_fixed_message'
                children={message}
              />
            )}
          </div>
        </FixedMessage>
      </div>
    )
  }
}

class NullNotifier {
  success(notification) {}

  info(notification) {}

  warn(notification) {}

  error(notification) {}
}

class DebuggingNotifier {
  success(notification) {
    /* eslint-disable-next-line no-console */
    console.log(notification)
  }

  info(notification) {
    /* eslint-disable-next-line no-console */
    console.log(notification)
  }

  warn(notification) {
    console.warn(notification)
  }

  error(notification) {
    console.error(notification)
  }
}

class FixedMessageNotifier {
  constructor() {
    this._containerDomNode = document.createElement('div')
    this._notificationSystem = createRef()

    document.body.appendChild(this._containerDomNode)

    render(
      <FixedMessageNotification ref={this._notificationSystem} />,
      this._containerDomNode
    )
  }

  _notifyAtLevel({ title, message, role }) {
    this._notificationSystem.current.notify({
      title,
      message,
      role,
    })
  }

  success(notification) {
    this._notifyAtLevel({
      ...notification,
      role: 'success',
    })
  }

  info(notification) {
    this._notifyAtLevel({
      ...notification,
      role: 'information',
    })
  }

  warn(notification) {
    this._notifyAtLevel({
      ...notification,
      role: 'warning',
    })
  }

  error(notification) {
    this._notifyAtLevel({
      ...notification,
      role: 'error',
    })
  }
}

/**
 * This is a mediocre excuse for an interface, but all notifications should be an object with at least these two keys
 * present
 */
const NotificationPropTypes = PropTypes.shape({
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
})

const NotifierPropTypes = PropTypes.shape({
  info: PropTypes.func.isRequired,
  success: PropTypes.func.isRequired,
  warn: PropTypes.func.isRequired,
  error: PropTypes.func.isRequired,
})

export {
  NotificationPropTypes,
  NotifierPropTypes, // TODO: remove this
  NullNotifier,
  DebuggingNotifier,
  FixedMessageNotifier,
}
